export function calculateDateDifference(
  start: Date,
  end: Date
): { days: number; weeks: number; months: number; years: number } {
  if (!end || !start) return { days: 0, weeks: 0, months: 0, years: 0 };

  const diffTime = Math.abs(end.getTime() - start.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  const diffWeeks = Math.floor(diffDays / 7);
  const diffMonths =
    (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
  const diffYears = end.getFullYear() - start.getFullYear();
  return { days: diffDays, weeks: diffWeeks, months: diffMonths, years: diffYears };
}
